// Pillar (ring) metadata — the actual crop/system/resource data comes from the
// seeded backend Knowledge Base (/api/kb/bootstrap), see lib/kbLogic.js.

export const PILLARS = [
  { id: "resources", label: "RESOURCES", grad: ["#3bbbc2", "#74D6DA"], solid: "#3bbbc2" },
  { id: "crops", label: "CROPS", grad: ["#71d85e", "#A2E893"], solid: "#71d85e" },
  { id: "systems", label: "SYSTEMS", grad: ["#f88528", "#FBAB63"], solid: "#f88528" },
  { id: "locations", label: "ZONES", grad: ["#51aafe", "#93C9FF"], solid: "#51aafe" },
];
export const PILLAR_IDS = PILLARS.map((p) => p.id);
export const PILLAR_BY_ID = Object.fromEntries(PILLARS.map((p) => [p.id, p]));
